import React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { FormSelectRow } from "./form-select-row";
import { WEEKDAYS } from "../courier-constants";
import FormModalShell from "../ui/form-modal-shell";
import { CourierActions } from "../ui/courier-fields";
import { ErrorField } from "components/ui/error-field";

const CreateScheduleForm = ({
  closeModal,
  loading,
  apiError,
  rounds = [],
  couriers = [],
  createCourierRoundSchedule
}) => (
  <FormModalShell title="Add Schedule" apiError={apiError} onClose={closeModal} columns={2}>
      <Formik
        initialValues={{
          round: "",
          weekday: 0,
          startTime: "09:00",
          defaultCourier: ""
        }}
        validationSchema={Yup.object().shape({
          round: Yup.string().required("Required field"),
          startTime: Yup.string().required("Required field")
        })}
        onSubmit={values => {
          const payload = {
            round: Number(values.round),
            weekday: Number(values.weekday),
            startTime: values.startTime
          };
          if (values.defaultCourier) {
            payload.defaultCourier = Number(values.defaultCourier);
          }
          createCourierRoundSchedule(payload);
        }}
      >
        {formik => (
          <Form>
            <FormSelectRow
              label="Round"
              name="round"
              value={formik.values.round}
              onChange={e => formik.setFieldValue("round", e.target.value)}
              error={formik.touched.round && formik.errors.round}
              required
              options={rounds.map(r => ({ value: r.id, label: r.code }))}
            />
            <FormSelectRow
              label="Weekday"
              name="weekday"
              value={formik.values.weekday}
              onChange={e =>
                formik.setFieldValue("weekday", Number(e.target.value))
              }
              searchable={false}
              options={WEEKDAYS.map(d => ({ value: d.value, label: d.label }))}
            />
            <div className="form-row">
              <label>Start Time</label>
              <input
                type="time"
                name="startTime"
                value={formik.values.startTime}
                onChange={e =>
                  formik.setFieldValue("startTime", e.target.value)
                }
              />
              {formik.touched.startTime && formik.errors.startTime && (
                <ErrorField value={formik.errors.startTime} />
              )}
            </div>
            <FormSelectRow
              label="Default Courier"
              name="defaultCourier"
              value={formik.values.defaultCourier}
              onChange={e =>
                formik.setFieldValue("defaultCourier", e.target.value)
              }
              placeholder="Optional"
              options={couriers.map(c => ({
                value: c.id,
                label: c.fullName || c.phone
              }))}
            />
            <CourierActions
              loading={loading}
              submitLabel="Add Schedule"
              onCancel={closeModal}
            />
          </Form>
        )}
      </Formik>
  </FormModalShell>
);

export default CreateScheduleForm;
